import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  play(event) {
    this.element.querySelectorAll('video').forEach(video => {
      if (video !== event.target) video.pause();
    });
  }
}
